import styled from 'styled-components'
import COLORS from '@colors'

export const St0 = styled.path`
  fill: ${COLORS.gray28};
`
export const St1 = styled.polygon`
  fill: ${COLORS.white};
`
export const St2 = styled.path`
  fill: ${COLORS.leather};
`
export const St3 = styled.path`
  fill: ${COLORS.whiteFd};
`
